// extracted by mini-css-extract-plugin
export default {"notifications-mapper":"okKBF","list":"nhqxX","notifications-mapper_expanded":"vNmMv","show":"emZ1t"};